// src/hooks/useInactivityHeartbeat.js
import { useEffect, useRef } from 'react';
import api from '../apiWithAccessToken'; // Ensure this points to your central API file

const useInactivityHeartbeat = () => {
  // Use refs to avoid re-renders
  const lastActivityRef = useRef(Date.now());
  const lastHeartbeatRef = useRef(Date.now());

  useEffect(() => {
    // 1. Define what counts as "Activity"
    const handleActivity = () => {
      lastActivityRef.current = Date.now();
    };

    // 2. Attach listeners to the window
    // We listen to these events to know the user is actually there
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('click', handleActivity);
    window.addEventListener('scroll', handleActivity);

    // 3. The Check Loop (Runs every 1 minute)
    const intervalId = setInterval(() => {
      const now = Date.now();
      const timeSinceLastActivity = now - lastActivityRef.current;
      const timeSinceLastHeartbeat = now - lastHeartbeatRef.current;

      // LOGIC:
      // 1. Is the user active? (Activity within the last 5 minutes)
      // 2. Have we NOT pinged recently? (Don't spam; only ping every 5 minutes)
      const isActive = timeSinceLastActivity < 5 * 60 * 1000; 
      const needsRefresh = timeSinceLastHeartbeat > 5 * 60 * 1000; 

      if (isActive && needsRefresh) {
        // Send the signal to the backend
        api.get('/heartbeat')
          .then(() => {
            // Update the heartbeat timestamp so we don't ping again too soon
            lastHeartbeatRef.current = now;
            console.log("Session extended due to UI activity.");
          })
          .catch((err) => {
            // If this fails (e.g. 401), the main Axios interceptor will handle the logout
            console.error("Heartbeat failed", err);
          });
      }
    }, 60 * 1000); // Check every minute

    // Cleanup listeners on unmount
    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('click', handleActivity);
      window.removeEventListener('scroll', handleActivity);
      clearInterval(intervalId);
    };
  }, []);
};

export default useInactivityHeartbeat;